<template>
    <div class="tw-my-4" v-if="showDatePreview">
        <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-font-semibold tw-mb-4 preview">
            <img :src="calendarIcon" alt="calendar icon" class="tw-mr-4" />
            <span>{{ date ? date : translate('dateTimePreview.select_date') }}</span>
            <a @click.prevent="$emit('edit-date')" href="#" class="tw-ml-auto tw-text-base tw-underline">
                {{ translate('dateTimePreview.edit') }}
            </a>
        </div>
        <div
            v-if="showTimePreview"
            class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-font-semibold tw-mb-4 preview"
        >
            <img :src="clockIcon" alt="clock icon" class="tw-mr-4" />
            <span>{{ time ? time : translate('dateTimePreview.select_time') }}</span>
            <a @click.prevent="$emit('edit-time')" href="#" class="tw-ml-auto tw-text-base tw-underline">
                {{ translate('dateTimePreview.edit') }}
            </a>
        </div>
    </div>
</template>
<script>
import calendarIcon from '@images/calendar.svg';
import { LocalDate, DateTimeFormatter } from '@js-joda/core';
import i18n from '@js/vue/mixins/i18n';
import clockIcon from '@images/clock-circular-outline.svg';
import { BOOKING_VIEWS } from '@js/vue/booking-views.js';
import { mapGetters } from 'vuex';

export default {
    mixins: [i18n],
    inject: ['lang', 'translations'],
    setup() {
        return { calendarIcon, clockIcon };
    },
    data() {
        return {
            dateDisplayedFormat: 'dd.MM.yyyy',
            BOOKING_VIEWS,
        };
    },
    methods: {
        formatDate(date) {
            const pattern = DateTimeFormatter.ofPattern(this.dateDisplayedFormat);
            return LocalDate.parse(date).format(pattern);
        },
    },
    props: ['activeView'],
    computed: {
        ...mapGetters('booking', ['getDate', 'getTime']),
        date() {
            return this.getDate;
        },
        time() {
            return this.getTime;
        },
        showTimePreview() {
            return this.activeView !== BOOKING_VIEWS.TIME_PICKER;
        },
        showDatePreview() {
            return (
                this.activeView !== BOOKING_VIEWS.CALENDAR &&
                this.activeView !== BOOKING_VIEWS.CUSTOMER_INFO_AND_PAYMENT
            );
        },
    },
};
</script>
